var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { APIData } from '../../../api/APIData';
export class MiniQuestionEdit {
    parent;
    isEditSelected = false;
    isMiniHovering = false;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get miniQuestion() {
        return this.parent;
    }
    get app() {
        return this.miniQuestion.app;
    }
    get midiDataQuery() {
        return new APIData({
            route: `/api/persistent/midiquestion/${this.miniQuestion.id}`,
            defaultValue: { text: '', questionStore: {}, questionTypeStore: {} },
        });
    }
    get midiData() {
        return this.midiDataQuery.streamedRef;
    }
    get isCurrentEditQuestion() {
        return this.app.editQuestion && this.miniQuestion.id === this.app.editQuestion.id;
    }
}
__decorate([
    observable
], MiniQuestionEdit.prototype, "isEditSelected", void 0);
__decorate([
    observable
], MiniQuestionEdit.prototype, "isMiniHovering", void 0);
__decorate([
    memoize
], MiniQuestionEdit.prototype, "midiDataQuery", null);
